export const KarmaScoreRange = {
    BELOW_AVERAGE : 60,
    AVERAGE : 80,
    GOOD : 98,
    INITIAL_VALUE : 20,
}